module.exports = __webpack_public_path__ + "images/emoji/snowflake.0e3c1639c3acd127acc8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/snowflake.png
// module id = +em6
// module chunks = 1